import {
  getPreselectedPaymentFrequency,
  hasBuildingCoverType,
  hasContentsCoverType,
} from 'scenes/landlord/selectors';
import {
  LandlordFlowDefinition,
  LandlordFlowType,
  LandlordFormAnswer,
  LandlordFunnelState,
  LandlordStepType,
} from 'scenes/landlord/types';
import config, { FeatureToggleState } from 'shared/config';

export const forwardLinks: LandlordFlowDefinition = {
  [LandlordStepType.QuotePrice]: (funnelState: LandlordFunnelState) => ({
    step: hasBuildingCoverType(funnelState)
      ? LandlordStepType.BuildingExcess
      : LandlordStepType.ContentsExcess,
  }),
  [LandlordStepType.BuildingExcess]: (funnelState: LandlordFunnelState) =>
    hasContentsCoverType(funnelState)
      ? { step: LandlordStepType.ContentsExcess }
      : {
          step: LandlordStepType.OptionalExtras,
        },
  [LandlordStepType.ContentsExcess]: {
    step: LandlordStepType.OptionalExtras,
  },

  [LandlordStepType.OptionalExtras]: (funnelState: LandlordFunnelState) => ({
    step: LandlordStepType.PropertyCondition,
    flow: LandlordFlowType.PolicyDetails,
    [LandlordFlowType.PolicyDetails]: {
      ...funnelState.policyDetails,
      preselectedPaymentFrequency: getPreselectedPaymentFrequency(funnelState),
    },
  }),
};

export const backwardLinks: LandlordFlowDefinition = {
  [LandlordStepType.QuotePrice]: {
    step:
      config.featureToggles.skipLandlordPromoPage === FeatureToggleState.ON
        ? LandlordStepType.FlybuysNumber
        : LandlordStepType.PromoCode,
    flow: LandlordFlowType.QuoteDetails,
  },
  [LandlordStepType.BuildingExcess]: { step: LandlordStepType.QuotePrice },
  [LandlordStepType.ContentsExcess]: (funnelState: LandlordFunnelState) => ({
    step: hasBuildingCoverType(funnelState)
      ? LandlordStepType.BuildingExcess
      : LandlordStepType.QuotePrice,
  }),
  [LandlordStepType.OptionalExtras]: (funnelState: LandlordFunnelState) => ({
    step: hasContentsCoverType(funnelState)
      ? LandlordStepType.ContentsExcess
      : LandlordStepType.BuildingExcess,
  }),
};

export const editCoverOptions = (
  funnelState: LandlordFunnelState,
  action: LandlordFormAnswer
) => ({
  step: action.targetStep,
  flow: LandlordFlowType.CoverOptions,
});
